"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = UnavailableException;
require("core-js/modules/es.function.name.js");
function UnavailableException(data) {
  this.name = 'UnavailableException';
  this.data = data;
  this.message = JSON.stringify(data);
  this.stack = new Error().stack;
}
UnavailableException.constructor = UnavailableException;